import MaintainTransLog from './MaintainTransLog.vue';

export default MaintainTransLog;


// WEBPACK FOOTER //
// ./src/components/MaintainTransLog/index.js